(function () {
  function initIngredientsTabs(section) {
    if (!section || section.dataset.haIngredientsTabsInitialized === "true") return;

    section.dataset.haIngredientsTabsInitialized = "true";

    const tabs = Array.from(section.querySelectorAll("[data-ha-ing-tab]"));
    const panels = Array.from(section.querySelectorAll("[data-ha-ing-panel]"));

    if (!tabs.length || !panels.length) return;

    const supportsHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    function activateTab(tab, shouldFocus) {
      if (!tab || tab.classList.contains("is-active")) return;

      const targetId = tab.getAttribute("data-tab-target");
      const targetPanel = section.querySelector("#" + CSS.escape(targetId));

      if (!targetPanel) return;

      tabs.forEach(function (item) {
        const isActive = item === tab;

        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-selected", isActive ? "true" : "false");
        item.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      panels.forEach(function (panel) {
        const isActive = panel === targetPanel;

        panel.classList.toggle("is-active", isActive);
        panel.setAttribute("aria-hidden", isActive ? "false" : "true");
      });

      if (shouldFocus) {
        tab.focus();
      }
    }

    function getNextTab(currentTab, direction) {
      const currentIndex = tabs.indexOf(currentTab);
      if (currentIndex === -1) return tabs[0];

      let nextIndex = currentIndex + direction;

      if (nextIndex < 0) nextIndex = tabs.length - 1;
      if (nextIndex >= tabs.length) nextIndex = 0;

      return tabs[nextIndex];
    }

    tabs.forEach(function (tab) {
      if (supportsHover) {
        tab.addEventListener("pointerenter", function () {
          activateTab(tab, false);
        });

        tab.addEventListener("focus", function () {
          activateTab(tab, false);
        });
      }

      tab.addEventListener("click", function () {
        activateTab(tab, false);
      });

      tab.addEventListener("keydown", function (event) {
        const key = event.key;
        let nextTab = null;

        if (key === "ArrowRight" || key === "ArrowDown") {
          nextTab = getNextTab(tab, 1);
        }

        if (key === "ArrowLeft" || key === "ArrowUp") {
          nextTab = getNextTab(tab, -1);
        }

        if (key === "Home") {
          nextTab = tabs[0];
        }

        if (key === "End") {
          nextTab = tabs[tabs.length - 1];
        }

        if (nextTab) {
          event.preventDefault();
          activateTab(nextTab, true);
        }
      });
    });
  }

  function initAllIngredientsTabs(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll("[data-ha-ingredients-tabs]");

    sections.forEach(initIngredientsTabs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllIngredientsTabs(document);
    });
  } else {
    initAllIngredientsTabs(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAllIngredientsTabs(event.target);
  });
})();